import { makeStyles, Paper, Typography } from '@material-ui/core';
import { useStateRef } from '@zennya/web-component-library/src';
import clsx from 'clsx';
import { isEmpty } from "lodash";
import 'mapbox-gl/dist/mapbox-gl.css';
import { useEffect, useMemo, useRef } from 'react';
import MapGL, { AttributionControl, Marker, NavigationControl } from 'react-map-gl';



const MAP_BOX_TOKEN = process.env.REACT_APP_MAPBOX_TOKEN;
const mapStyleUnshrink = {
  width: '100%',
  minHeight: '200px',
};

const mapStyleShrink = {
  width: '100%',
  height: '40vh'
}

const INIT_CENTER = {
  latitude: 14.58,
  longitude: 121.0
}


const useStyles = makeStyles((theme) => {
  return {
    marker: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    pin: {
      width: '30px',
      height: 'auto',
    },
    staticPin: {
      zIndex: 999,
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, calc(50% - 75px))',

    }
  }
})
const MapBox = ({
  style = {},
  center,
  markerLocation,
  onMarkerDragEnd,
  draggable = false,
  canvasDrag = false,
  onRef = () => { },
  shrink = false,
  children
}) => {
  const classes = useStyles()
  const [map, setMap, mapRef] = useStateRef();

  const hasCenterRef = useRef(null);

  const markers = useMemo(() => {
    if (isEmpty(markerLocation)) {
      return
    }
    return [markerLocation]?.map((item, index) => {
      if (item?.latitude && item?.longitude) {
        return (
          <Marker
            key={`mk-${index}`}
            longitude={item?.longitude}
            latitude={item?.latitude}
            anchor="bottom"
            draggable={draggable && !canvasDrag}
            onDragEnd={(evt) => {
              if (onMarkerDragEnd) {
                onMarkerDragEnd(evt.lngLat)
              }
            }}

          >
            <div className={classes.marker}>
              {draggable && <Typography component={Paper} variant='caption'>Drag to fine tune location</Typography>}
              <img src="/assets/images/clientPin.png" className={classes.pin} alt="marker" />
            </div>
          </Marker>
        )
      }
      return null
    })
  }, [markerLocation]);

  const viewPort = useMemo(() => {
    const cpdata = isEmpty(center) ? INIT_CENTER : center;
    const rcp = {
      bearing: 0,
      pitch: 0,
    }
    return rcp
  }, [center]);


  useEffect(() => {
    if (mapRef?.current) {
      onRef(mapRef?.current);
      //restrict deftype to EXCLUSIVELY number
      if (center?.longitude && center?.latitude && !hasCenterRef?.current) {
        if (isNaN(center?.longitude) || isNaN(center?.latitude)) {
        } else {
          mapRef?.current?.setCenter([center?.longitude, center?.latitude]);
          hasCenterRef.current = true;
        }
      }
    }
  }, [center?.longitude, center?.latitude, mapRef?.current]);

  const mapStyle = shrink ? mapStyleShrink : mapStyleUnshrink;
  return (
    <MapGL
      reuseMaps
      style={{ ...mapStyle, ...style }}
      initialViewState={{
        zoom: 17
      }}
      scrollZoom={false}
      touchZoomRotate={canvasDrag}
      dragPan={canvasDrag ? { deceleration: 10000 } : false}
      mapStyle="mapbox://styles/mapbox/streets-v11"
      mapboxAccessToken={MAP_BOX_TOKEN}
      ref={(ref) => setMap(ref)}
      attributionControl={false}
      {...viewPort}
      onDragEnd={(evt) => {
        if (canvasDrag && onMarkerDragEnd) {
          onMarkerDragEnd({ lat: evt?.viewState?.latitude, lng: evt?.viewState?.longitude })
        }
      }}
    >
      {canvasDrag ? <img src="/assets/images/clientPin.png" className={clsx(classes.pin, classes.staticPin)} alt="marker" /> : markers}
      {children}
      <NavigationControl />
      <AttributionControl compact position='top-right' />
    </MapGL>

  )
}

export { MapBox };
